import { IntlShape, useIntl } from 'react-intl'

let INTL: IntlShape
const NotificationEvents = (props: any) => {
  INTL = useIntl()
  return props.children
}

let instance: any
class Notification {
  constructor() {
    if (!instance) {
      instance = this
    }
    return instance
  }

  sendNotification = (type: string, messageId: string) => {
    window.dispatchEvent(
      new CustomEvent('sendNotification', { detail: { type, message: INTL.formatMessage({ id: messageId }) } })
    )
  }
}

export const notification = new Notification()
export default NotificationEvents
